import { render, staticRenderFns } from "./categorias.arbol.list.tree.vue?vue&type=template&id=41c687e9&scoped=true&"
import script from "./categorias.arbol.list.tree.vue?vue&type=script&lang=js&"
export * from "./categorias.arbol.list.tree.vue?vue&type=script&lang=js&"
import style0 from "./categorias.arbol.list.tree.vue?vue&type=style&index=0&id=41c687e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c687e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VCheckbox,VIcon,VListItem})
